import React, { type ReactNode } from 'react'

import './VisuallyHidden.css'

type VisuallyHiddenProps = {
  tag?: string
  children: ReactNode
}

const VisuallyHidden = ({ tag = 'div', children }: VisuallyHiddenProps): JSX.Element =>
  React.createElement(tag, { className: 'VisuallyHidden' }, children)

export { VisuallyHidden }
